<template>
  <div class="header-controls project-header-controls" id="header__controls">
    <b-modal centered hide-footer id="feedbackModal" title="Send Feedback">
      <FeedbackModal ref="refFeedbackModal" />
    </b-modal>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-7 col-md-8 col-8 left-side">
          <div :class="$router.currentRoute.name != 'project' && $router.currentRoute.name != 'myProjects' ? 'd-none' : ''" class="form-inline" v-if="$router.currentRoute.name != 'permissionManager' && $router.currentRoute.name != 'globalAlert' && $router.currentRoute.name != 'userGlobalAlert'">
            <div class="input-group top-search">
              <input
                type="text"
                class="form-control"
                :class="$router.currentRoute.name == 'globalSearch' ? '' : 'media-calls-search'"
                v-model="searchQuery"
                v-debounce:500ms="setQuery"
                :debounce-events="['keyup']"
                :placeholder="$router.currentRoute.name == 'globalSearch' ? 'Global search...' : 'Search projects...'"
                @click="$refs.searchQuery.select()"
                @keypress.enter="triggerSearch"
                ref="searchQuery"
                id="search-query"
              />
              <div class="input-group-append cursor-pointer" @click="triggerSearch">
                <span class="input-group-text">
                  <i class="fas fa-search"></i>
                </span>
              </div>
            </div>
            <b-button
              ref="filterBoxBtn"
              id="popover-button-event"
              class="ml-2 header-filter-btns"
              variant="theme"
              tabindex="0"
              href="#"
              v-if="$router.currentRoute.name != 'globalSearch'"
              @keydown.esc="$refs.popover.$emit('close')"
            >
              <span class="wider-filter-only">Filter</span>
              <img src="@/csmworkflow/img/filter.svg" />
            </b-button>
            <b-popover
              triggers="click blur"
              boundary="window"
              placement="bottom"
              ref="popover"
              target="popover-button-event"
              custom-class="deliverable-filter"
            >
              <div class="d-flex flex-row">
                <div class="grouped-filter-item">
                  <div class="filter-item item__status">
                    <label>Project Status</label>
                    <div v-if="!isMobile()" class="status-wrap">
                      <a
                        href="#"
                        @click="setStatusFilter(s)"
                        class="badge mr-2"
                        :style="{color: 'var(--wf-secondary)', backgroundColor: s.color}"
                        v-for="(s, index) in statuses"
                        :key="index"
                      >{{ s.name }}</a>
                    </div>
                    <div class="custom-field status-field">
                      <multiselect
                        v-if="isMobile()"
                        :searchable="true"
                        v-model="filterQuery.status"
                        label="name"
                        :options="statuses"
                        placeholder="Select status"
                        :show-labels="false"
                        :multiple="true"
                        :hide-selected="true"
                      >
                        <template slot="option" slot-scope="props">
                          <div
                            :style="{ color: 'var(--wf-secondary)', borderRadius: '10px', backgroundColor: props.option.color, height: '40px', lineHeight: '40px', textAlign: 'center' }"
                          >{{ props.option.name }}</div>
                        </template>
                        <template slot="tag" slot-scope="props">
                          <div
                            :style="{ color: 'var(--wf-secondary)', borderRadius: '10px', backgroundColor: props.option.color, textAlign: 'center', display: 'inline-block', padding: '5px 10px', marginRight: '5px' }"
                          >{{ props.option.name }}</div>
                        </template>
                      </multiselect>
                    </div>
                  </div>
                </div>
                <div class="grouped-filter-item">
                  <div class="filter-item item__coordinator">
                    <label>Assigned To</label>
                    <b-form-checkbox
                        v-if="$router.currentRoute.name == 'project' && isMobile()"
                        class="float-right csm-checkbox"
                        v-model="filterQuery.noCoordinator"
                        id="no-coordinator"
                        name="no-coordinator"
                        value="accepted"
                        unchecked-value="not_accepted"
                        @input="filterQuery.noCoordinator == 'accepted' ? filterQuery.coordinator = [] : ''"
                      >Not Assigned To Anyone</b-form-checkbox>
                    <div class="coordinator-wrap">
                      <multiselect
                        ref="coordinatorFilter"
                        v-model="filterQuery.coordinator"
                        :options="allActiveUsers"
                        :show-labels="false"
                        :multiple="true"
                        open-direction="bottom"
                        label="name"
                        track-by="id"
                        :hide-selected="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                      >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span
                            class="multiselect__single"
                            v-if="values.length && !isOpen"
                          >{{ values.length }} options selected</span>
                        </template>
                      </multiselect>
                    </div>
                    <b-form-checkbox
                      v-if="$router.currentRoute.name == 'project' && !isMobile()"
                      class="mt-2 csm-checkbox"
                      v-model="filterQuery.noCoordinator"
                      id="no-coordinator"
                      name="no-coordinator"
                      value="accepted"
                      unchecked-value="not_accepted"
                      @input="filterQuery.noCoordinator == 'accepted' ? filterQuery.coordinator = [] : ''"
                    >Not Assigned To Anyone</b-form-checkbox>
                  </div>
                  <div class="filter-item item__department">
                    <div>
                      <label>Department</label>
                      <b-form-checkbox
                        v-if="isMobile()"
                        class="float-right csm-checkbox"
                        v-model="filterQuery.noDepartment"
                        id="no-department"
                        name="no-department"
                        value="accepted"
                        unchecked-value="not_accepted"
                        @input="filterQuery.noDepartment == 'accepted' ? filterQuery.department = [] : ''"
                      >No Department</b-form-checkbox>
                    </div>
                    <div class="tag-wrap">
                      <multiselect
                        ref="departmentFilter"
                        v-model="filterQuery.department"
                        open-direction="bottom"
                        label="name"
                        track-by="id"
                        :options="departments"
                        :hide-selected="true"
                        :show-labels="false"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        @select="filterQuery.noDepartment = 'not_accepted'"
                      >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span
                            class="multiselect__single"
                            v-if="values.length && !isOpen"
                          >{{ values.length }} options selected</span>
                        </template>
                        <template slot="noOptions">Start typing to find departments.</template>

                        <template slot="noResult">No results. Please try changing the search query.</template>
                      </multiselect>
                    </div>
                    <b-form-checkbox
                      v-if="!isMobile()"
                      class="mt-2 csm-checkbox"
                      v-model="filterQuery.noDepartment"
                      id="no-department"
                      name="no-department"
                      value="accepted"
                      unchecked-value="not_accepted"
                      @input="filterQuery.noDepartment == 'accepted' ? filterQuery.department = [] : ''"
                    >No Department</b-form-checkbox>
                  </div>
                </div>
                <div class="filter-item filter-item-no-border item__date">
                  <div class="due__created__dates">
                    <div>
                      <label>Due Date</label>
                      <br />
                      <date-range-picker
                        ref="picker"
                        @update="onUpdateDueDate"
                        :autoApply="true"
                        :ranges="customDueDateRanges"
                        v-model="filterQuery.dateRange"
                      ></date-range-picker>
                    </div>
                    <div>
                      <label class="mt-2">Created</label>
                      <br />
                      <date-range-picker
                        ref="pickerDateCreated"
                        @update="onUpdateDateCreated"
                        :autoApply="true"
                        :ranges="customCreatedDateRanges"
                        v-model="filterQuery.dateCreatedRange"
                      ></date-range-picker>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="item__reset">
                    <b-button variant="theme" title="Reset All Filter" size="sm" @click="resetFilter"><i class="fas fa-undo"></i></b-button>
                    <b-button class="d-block d-lg-none" variant="theme" title="Close Filter Popup" size="sm" @click="$refs.popover.$emit('close')"><i class="fas fa-times"></i></b-button>
                  </div>
                </div>
              </div>
              <div
                class="d-none d-md-block mt-3 test1"
                v-if="isFilterActive()"
              >
                <label>Click to remove filters:</label>
                <br />
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="filterQuery.query = null; searchQuery = ''"
                  :style="{cursor: 'pointer'}"
                >{{ filterQuery.query }}</span>
                <span
                  class="badge mr-2 mb-2"
                  @click="removeFilter(status)"
                  :style="{cursor: 'pointer', color: 'var(--wf-secondary)', backgroundColor: status.color}"
                  v-for="status in filterQuery.status"
                >{{ status.name }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(outlet)"
                  :style="{cursor: 'pointer'}"
                  v-for="outlet in filterQuery.outlet"
                >{{ outlet.name }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(deliverableType)"
                  :style="{cursor: 'pointer'}"
                  v-for="deliverableType in filterQuery.deliverableType"
                >{{ deliverableType.name }}</span>
                <span
                  v-if="filterQuery.priorityFilter > 0"
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('resetPriorityFilter')"
                  :style="{cursor: 'pointer'}"
                >Priority {{ filterQuery.priorityFilter }}</span>
                <span
                  v-if="$router.currentRoute.name != 'globalSearch' && filterQuery.sort"
                  class="badge mr-2 mb-2 bg-primary cursor-pointer"
                  style="color: var(--wf-secondary);"
                  @click="removeFilter('sort')"
                >
                  Sorting Active
                </span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(coordinator)"
                  :style="{cursor: 'pointer'}"
                  v-for="coordinator in filterQuery.coordinator"
                >{{ coordinator.name }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('filterByDate')"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.filterByDate"
                >Due Date: {{ filterQuery.dateRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateRange.endDate | moment('MMM DD') }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="filterQuery.filterNoDueDate=false"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.filterNoDueDate == 1"
                >No Due Date</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('filterByDateCreated')"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.filterByDateCreated"
                >Created: {{ filterQuery.dateCreatedRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateCreatedRange.endDate | moment('MMM DD') }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('filterByDateCompleted')"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.filterByDateCompleted"
                >Completed: {{ filterQuery.dateCompletedRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateCompletedRange.endDate | moment('MMM DD') }}</span>

                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(tag)"
                  :style="{cursor: 'pointer'}"
                  v-for="tag in filterQuery.tag"
                >{{ tag.name }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(department)"
                  :style="{cursor: 'pointer'}"
                  v-for="department in filterQuery.department"
                >{{ department.name }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="filterQuery.noDepartment='not_accepted'"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.noDepartment == 'accepted'"
                >No Department</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="filterQuery.noCoordinator='not_accepted'"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.noCoordinator == 'accepted'"
                >No Coordinator</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="filterQuery.noOutlet='not_accepted'"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.noOutlet == 'accepted'"
                >No Outlet</span>
              </div>
            </b-popover>

            <b-button
              class="ml-2 header-filter-btns"
              variant="theme"
              @click="createNewProject()"
              v-if="userCanCreateProject"
            >
              Project
              <i class="fas text-primary float-right fa-plus fa-fw"></i>
            </b-button>

            <div class="ml-2 wider-filter-only">
              <div class="filter-project-department-wrap report-type audit-log-user" style="max-width: 200px">
                <multiselect
                  ref="departmentFilter"
                  v-model="filterQuery.department"
                  open-direction="bottom"
                  label="name"
                  track-by="id"
                  :options="departments"
                  :hide-selected="true"
                  :show-labels="false"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  @select="filterQuery.noDepartment = 'not_accepted'"
                  placeholder="Filter by department"
                >
                  <template slot="selection" slot-scope="{ values, search, isOpen }">
                    <span
                      class="multiselect__single"
                      v-if="values.length && !isOpen"
                    >{{ values.length }} options selected</span>
                  </template>
                  <template slot="noOptions">Start typing to find departments.</template>

                  <template slot="noResult">No results. Please try changing the search query.</template>
                </multiselect>
              </div>
            </div>

            <div
              class="ml-2 project-sort mobile-sort cursor-pointer mobile-filter-only"
              v-if="$router.currentRoute.name != 'projectDeliverable'"
            >
              <b-button
                class="header-sort-btns auto-width-button"
                variant="theme"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span v-if="currentSort" class="icon"><i :class="`fas text-primary ${currentSort.icon}`"></i></span>
                <span v-else class="icon"><i :class="`fas text-primary fa-sort-amount-down`"></i></span>
              </b-button>
              <!-- Sorting dropdown -->
              <div class="dropdown-menu sortmenu-dropdown">
                <div>
                  <perfect-scrollbar class="sort__scroll" ref="sort__scroll">
                    <div>
                      <a
                        class="dropdown-item"
                        v-for="(sortOption, index) in sortOptions"
                        :class="{active : currentSort.id == sortOption.id}"
                        :key="'projectSort'+index+1*Math.random()"
                        @click="setSort(sortOption)"
                        >
                        <div class="preset-icon-wrap"></div>
                        <span class="sort-title">{{sortOption.title}}</span>
                      </a>
                    </div>
                  </perfect-scrollbar>
                </div>
              </div>
            </div>

            <div
              class="ml-2 mobile-views-section cursor-pointer mobile-filter-only"
              v-if="$router.currentRoute.name != 'projectDeliverable'"
            >
              <b-button
                class="header-view-btns auto-width-button"
                variant="theme"
                ref="MobileViewButton"
                id="MobileViewButton"
                v-b-modal.headerViewSelectModal
              >
                <span class="icon"><i class="fas fa-fw fa-eye text-primary"></i></span>
              </b-button>

            </div>

            <div
              v-if="$router.currentRoute.name == 'globalSearch'"
              class="btn-group add-new__global_search"
            >
              <b-button
                @keydown.esc="$refs.GSCreatedDatePopover.$emit('close')"
                class="ml-md-2 header-filter-btns"
                variant="theme"
                @click="GSCreatedDatePopover = !GSCreatedDatePopover"
                ref="GSCreatedDate"
                id="GSCreatedDate"
              >
                Created Date
                <i class="far fa-calendar-check text-primary"></i>
              </b-button>
              <b-popover
                ref="GSCreatedDatePopover"
                :show.sync="GSCreatedDatePopover"
                target="GSCreatedDate"
                triggers="click blur"
                placement="bottom"
                custom-class="filter_popover__gs created-date-popover"
              >
                <date-range-picker
                  ref="pickerDateCreated"
                  opens="inline"
                  @update="onUpdateDateCreated"
                  :autoApply="true"
                  :ranges="customCreatedDateRanges"
                  v-model="filterQuery.dateCreatedRange"
                ></date-range-picker>
              </b-popover>
            </div>
            <div
              v-if="$router.currentRoute.name == 'globalSearch' && (GSDataType == 'departments' || GSDataType == 'tags' || GSDataType == 'contacts' || GSDataType == 'coordinators')"
              class="btn-group add-new__global_search"
            >
              <div
                class="ml-md-2 toggle-dept-status cursor-pointer"
                @click="filterQuery.status[0] == 'Active' ? filterQuery.status = ['Archived'] : filterQuery.status = ['Active']"
              >
                <b-button
                  class="header-filter-btns"
                  :class="{'none-active-btn': filterQuery.status[0] != 'Active'}"
                  variant="theme"
                >
                  Active
                  <i class="fas fa-toggle-on text-primary float-right ml-2"></i>
                </b-button>
                <b-button
                  class="header-filter-btns"
                  :class="{'none-active-btn': filterQuery.status[0] != 'Archived'}"
                  variant="theme"
                >
                  Archived
                  <i class="fas fa-toggle-off text-primary float-right ml-2"></i>
                </b-button>
              </div>
            </div>
            <div
              v-if="$router.currentRoute.name == 'globalSearch' && (GSDataType == 'departments' || GSDataType == 'tags')"
              class="btn-group add-new__global_search sorting"
            >
              <button
                class="btn btn-theme ml-md-2 header-filter-btns dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Sort
                <i class="fas fa-sort text-primary float-right"></i>
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item" @click="setSort('usedDesc')" href="#">Frequency Decending</a>
                <a class="dropdown-item" @click="setSort('usedAsc')" href="#">Frequency Ascending</a>
              </div>
            </div>
            <div
              v-if="$router.currentRoute.name == 'globalSearch' && GSDataType == 'all'"
              class="btn-group add-new__global_search"
            >
              <b-button
                class="ml-md-2 header-filter-btns dropdown-toggle"
                variant="theme"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >Add</b-button>
              <div class="dropdown-menu">
                <a
                  v-if="userAbilities.createTag || userAbilities.editMediaCall"
                  class="dropdown-item"
                  @click="$emit('click', 'tag')"
                  href="#"
                >Add Tags</a>
                <a
                  v-if="userAbilities.createContact || userAbilities.editMediaCall"
                  class="dropdown-item"
                  @click="$emit('click', 'contact')"
                  href="#"
                >Add Contacts</a>
                <a
                  v-if="userAbilities.createUser"
                  class="dropdown-item"
                  @click="$emit('click', 'coordinator')"
                  href="#"
                >Add Coordinators</a>
                <a
                  v-if="userAbilities.createDepartment || userAbilities.editMediaCall"
                  class="dropdown-item"
                  @click="$emit('click', 'department')"
                  href="#"
                >Add Departments</a>
              </div>
            </div>
            <div
              v-if="$router.currentRoute.name == 'globalSearch' && GSDataType != 'all'"
              :class="!checkPermissions ? 'no-permission' : ''"
              class="btn-group add-new__global_search specific-btn"
            >
              <b-button
                v-if="checkPermissions"
                @click.prevent="$emit('click', GSDataType.substring(0, GSDataType.length - 1))"
                variant="theme"
                class="ml-md-2 header-filter-btns action"
              >
                Add
                <span style="text-transform: capitalize">{{ tabType }}</span>
              </b-button>
              <div class="btn-group">
                <button
                  type="button"
                  v-if="checkPermissions"
                  class="btn btn-theme dropdown-toggle options"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <b-button
                  class="ml-md-2 header-filter-btns dropdown-toggle"
                  v-if="!checkPermissions"
                  variant="theme"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >Add</b-button>
                <div class="dropdown-menu">
                  <a
                    v-if="GSDataType != 'tags' && (userAbilities.createTag || userAbilities.editMediaCall)"
                    class="dropdown-item"
                    @click="$emit('click', 'tag')"
                    href="#"
                  >Add Tags</a>
                  <a
                    v-if="GSDataType != 'contacts' && (userAbilities.createContact || userAbilities.editMediaCall)"
                    class="dropdown-item"
                    @click="$emit('click', 'contact')"
                    href="#"
                  >Add Contacts</a>
                  <a
                    v-if="GSDataType != 'coordinators' && userAbilities.createUser"
                    class="dropdown-item"
                    @click="$emit('click', 'coordinator')"
                    href="#"
                  >Add Coordinators</a>
                  <a
                    v-if="GSDataType != 'departments' && (userAbilities.createDepartment || userAbilities.editMediaCall)"
                    class="dropdown-item"
                    @click="$emit('click', 'department')"
                    href="#"
                  >Add Departments</a>
                </div>
              </div>
            </div>
            <div class="ml-2">
              <FeedbackBtn />
            </div>
          </div>
          <div :class="$router.currentRoute.name != 'projectDeliverable' ? 'd-none' : ''">
            <b-button
              class="ml-2 header-filter-btns"
              variant="theme"
              @click="createNewProject()"
              v-if="userCanCreateProject"
            >
              Project
              <i class="fas text-primary float-right fa-plus fa-fw"></i>
            </b-button>
          </div>
          <div
            class="mt-3 filter-badges"
            v-if="isFilterActive()"
          >
            <label class="remove-filter-text">Click to remove filters:</label>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="filterQuery.query = null; searchQuery = ''"
              :style="{cursor: 'pointer'}"
            >{{ filterQuery.query }}</span>
            <span
              v-if="$router.currentRoute.name != 'globalSearch'"
              class="badge mr-2 mb-2"
              @click="removeFilter(status)"
              :style="{cursor: 'pointer', color: 'var(--wf-secondary)', backgroundColor: status.color}"
              v-for="status in filterQuery.status"
            >{{ status.name }}</span>
            <span
              v-if="$router.currentRoute.name == 'globalSearch'"
              class="badge mr-2 mb-2 bg-primary cursor-pointer"
              style="color: var(--wf-secondary);"
              @click="removeFilter('resetDepartStatus')"
            >{{ filterQuery.status[0] }}</span>
            <span
              v-if="$router.currentRoute.name == 'globalSearch' && filterQuery.sort"
              class="badge mr-2 mb-2 bg-primary cursor-pointer"
              style="color: var(--wf-secondary);"
              @click="removeFilter('resetDepartTagSort')"
            >{{ filterQuery.sort == 'usedDesc' ? 'Frequency Descending' : 'Frequency Ascending' }}</span>
            <span
                  v-if="filterQuery.priorityFilter > 0"
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('resetPriorityFilter')"
                  :style="{cursor: 'pointer'}"
                >Priority {{ filterQuery.priorityFilter }}</span>
            <span
              v-if="$router.currentRoute.name != 'globalSearch' && filterQuery.sort"
              class="badge mr-2 mb-2 bg-primary cursor-pointer"
              style="color: var(--wf-secondary);"
              @click="removeFilter('sort')"
            >
              Sorting Active
            </span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(outlet)"
              :style="{cursor: 'pointer'}"
              v-for="outlet in filterQuery.outlet"
            >{{ outlet.name }}</span>
            <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(deliverableType)"
                  :style="{cursor: 'pointer'}"
                  v-for="deliverableType in filterQuery.deliverableType"
                >{{ deliverableType.name }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(coordinator)"
              :style="{cursor: 'pointer'}"
              v-for="coordinator in filterQuery.coordinator"
            >{{ coordinator.name }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('filterByDate')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.filterByDate"
            >Due Date: {{ filterQuery.dateRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateRange.endDate | moment('MMM DD') }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="filterQuery.filterNoDueDate=false"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.filterNoDueDate == 1"
            >No Due Date</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('filterByDateCreated')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.filterByDateCreated"
            >Created: {{ filterQuery.dateCreatedRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateCreatedRange.endDate | moment('MMM DD') }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('filterByDateCompleted')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.filterByDateCompleted"
            >Completed: {{ filterQuery.dateCompletedRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateCompletedRange.endDate | moment('MMM DD') }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(tag)"
              :style="{cursor: 'pointer'}"
              v-for="tag in filterQuery.tag"
            >{{ tag.name }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(department)"
              :style="{cursor: 'pointer'}"
              v-for="department in filterQuery.department"
            >{{ department.name }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="filterQuery.noDepartment='not_accepted'"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.noDepartment == 'accepted'"
            >No Department</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="filterQuery.noCoordinator='not_accepted'"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.noCoordinator == 'accepted'"
            >No Coordinator</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="filterQuery.noOutlet='not_accepted'"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.noOutlet == 'accepted'"
            >No Outlet</span>
          </div>
        </div>
        <div class="col-sm-5 col-md-4 col-4 text-right right-side">
          <div class="logo-user">
            <HeaderNotification />
            <LoggedInUser />
            <Logo />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Logo from "./Logo";
import LoggedInUser from "./LoggedInUser";
import HeaderNotification from "./HeaderNotification";
import FeedbackBtn from "./FeedbackBtn";
import FeedbackModal from "./FeedbackModal";
import ViewTitleModal from "./ViewTitleModal";
import router from "../../routes";
import vueStarRate from "vue-js-star-rating";

export default {
  props: ["myWeek", "GSDataType"],
  data() {
    return {
      deliverableType: [],
      GSCreatedDatePopover: false,
      customDueDateRanges: {
        "No Due Date": [null, null],
        Yesterday: [
          this.$moment().subtract(1, "days").toDate(),
          this.$moment().subtract(1, "days").toDate(),
        ],
        "Last week": [
          this.$moment().subtract(7, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        "Last two week": [
          this.$moment().subtract(14, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        Today: [this.$moment().toDate(), this.$moment().toDate()],
        "This week": [
          this.$moment().startOf("week").toDate(),
          this.$moment().endOf("week").toDate(),
        ],
        "Next week": [
          this.$moment().startOf("week").add(7, "days").toDate(),
          this.$moment().endOf("week").add(7, "days").toDate(),
        ],
        "Next two weeks": [
          this.$moment().startOf("week").add(7, "days").toDate(),
          this.$moment().endOf("week").add(14, "days").toDate(),
        ],
      },
      customCreatedDateRanges: {
        Yesterday: [
          this.$moment().subtract(1, "days").toDate(),
          this.$moment().subtract(1, "days").toDate(),
        ],
        "Last week": [
          this.$moment().subtract(7, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        "Last two week": [
          this.$moment().subtract(14, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        Today: [this.$moment().toDate(), this.$moment().toDate()],
        "This week": [
          this.$moment().startOf("week").toDate(),
          this.$moment().endOf("week").toDate(),
        ],
      },
      customCompletedDateRanges: {
        Yesterday: [
          this.$moment().subtract(1, "days").toDate(),
          this.$moment().subtract(1, "days").toDate(),
        ],
        "Last week": [
          this.$moment().subtract(7, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        "Last two week": [
          this.$moment().subtract(14, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        Today: [this.$moment().toDate(), this.$moment().toDate()],
        "This week": [
          this.$moment().startOf("week").toDate(),
          this.$moment().endOf("week").toDate(),
        ],
      },
      searchQuery: "",
      isContactsLoading: false,
      isTagsLoading: false,
      isDepartmentsLoading: false,
      contacts: [],
      tags: [],
      departments: [],
      showUserSelect: false,
      expandAll: !this.isMobile(),
      filterQuery: {
        sort: "",
        query: "",
        filterByDate: false,
        dateRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        dateCreatedRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        department: [],
        coordinator: [],
        priorityFilter: 0,
        noDepartment: "not_accepted",
        noCoordinator: "not_accepted",
        status: [],
      },
    };
  },
  components: {
    Logo,
    vueStarRate,
    HeaderNotification,
    LoggedInUser,
    FeedbackBtn,
    FeedbackModal,
    ViewTitleModal,
  },
  computed: {
    ...mapGetters([
      "deliverableTypes",
      "allCustomFields",
      "allUsers",
      "allActiveUsers",
      "allContacts",
      "allTags",
      "deliverableFilter",
      "myWeekDeliverableFilter",
      "projectFilter",
      "myProjectFilter",
      "globalSearchFilter",
      "initialContacts",
      "initialTags",
      "initialDepartments",
      "userAbilities",
      "GSRecentSearch",
      "userViews"
    ]),
    statuses() {
      let statusField = _.find(this.allCustomFields, { field_key: "project_status" });
      if (typeof statusField != "undefined") {
        let valueSet = [],
          data = JSON.parse(statusField.value_set);
        Object.keys(data).forEach(function (item) {
          valueSet.push(data[item]);
        });
        return valueSet;
      } else {
        this.fetchAllCustomFields();
      }
    },
    checkPermissions() {
      switch (this.GSDataType) {
        case "tags":
          return (
            this.userAbilities.createTag || this.userAbilities.editMediaCall
          );
        case "contacts":
          return (
            this.userAbilities.createContact || this.userAbilities.editMediaCall
          );
        case "coordinators":
          return this.userAbilities.createUser;
        case "departments":
          return (
            this.userAbilities.createDepartment ||
            this.userAbilities.editMediaCall
          );
      }
    },
    tabType() {
      return typeof this.GSDataType != "undefined" ? this.GSDataType : "";
    },
    userCanCreateProject() {
      return this.userAbilities.createProject;
    },

    // Hardcoded sorts
		sortOptions() {
			return [
				{
					id: 1,
					title: 'Name (A-Z)',
					sortString: 'titleAsc',
					icon: 'fa-sort-alpha-down'
				},
				{
					id: 2,
					title: 'Name (Z-A)',
					sortString: 'titleDesc',
					icon: 'fa-sort-alpha-up'
				},
				{
					id: 3,
					title: 'Department (A-Z)',
					sortString: 'departmentAsc',
					icon: 'fa-sort-alpha-down',
          default: true
				},
				{
					id: 4,
					title: 'Department (Z-A)',
					sortString: 'departmentDesc',
					icon: 'fa-sort-alpha-up'
				},
			];
		},
    currentSort() {
      if (this.$router.currentRoute.name == 'project') {
        return _.filter(this.sortOptions, {sortString: this.$store.getters.projectSort || "departmentAsc"})[0];
      } else if (this.$router.currentRoute.name == 'myProjects') {
        return _.filter(this.sortOptions, {sortString: this.$store.getters.myProjectSort || "departmentAsc"})[0];
      }
    },
  },
  created() {
    // this.$store.dispatch('fetchProjects');
  },
  mounted() {
    // this.getDeliverableTypes();
    // hiding the header logo when scrolling in mobile
    if(this.isMobile() && this.$store.getters.isLoggedIn) {
      $('html').removeClass('is__safari');
      var prevScrollpos = window.pageYOffset;
      window.onscroll = function() {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
          document.getElementById("header__controls").style.top = "0";
        } else {
          document.getElementById("header__controls").style.top = "-60px";
        }
        prevScrollpos = currentScrollPos;
      }
    }

    this.$root.$on('bv::popover::show', bvEventObj => {
      $('body').addClass('popover-shown');
    });
    this.$root.$on('bv::popover::hide', bvEventObj => {
      $('body').removeClass('popover-shown');
    });
    this.$root.$on('setSaveView', () => {
			this.loadView();
		});
		this.$root.$on('resetFilter', () => {
			this.resetFilter();
		});
    this.onWhoSearch("");
    this.onTagSearch("");
    this.onDepartmentSearch("");

    if (router.currentRoute.name == "project") {
      this.filterQuery = this.projectFilter;
    } else if (router.currentRoute.name == "myProjects") {
      this.filterQuery = this.myProjectFilter;
    }
    if (!this.filterQuery.filterByDate) {
      this.filterQuery.dateRange = {
        startDate: new Date(),
        endDate: new Date(),
      };
    }
    if (!this.filterQuery.filterByDateCreated) {
      this.filterQuery.dateCreatedRange = {
        startDate: new Date(),
        endDate: new Date(),
      };
    }
    if (!this.filterQuery.filterByDateCompleted) {
      this.filterQuery.dateCompletedRange = {
        startDate: new Date(),
        endDate: new Date(),
      };
    }
  },
  methods: {
    ...mapActions(['getDeliverableTypes','fetchAllCustomFields']),
    ...mapMutations(["setDataLoading"]),
    isFilterActive() {
      return (
        this.filterQuery.noCoordinator == 'accepted'
        || this.filterQuery.noDepartment == 'accepted'
        || this.filterQuery.filterNoDueDate
        || this.filterQuery.query
        || this.filterQuery.filterByDate
        || this.filterQuery.filterByDateCreated
        || this.filterQuery.coordinator.length
        || this.filterQuery.department.length
        || this.filterQuery.sort
        || this.filterQuery.priorityFilter > 0
        || this.filterQuery.status.length
      );
    },
    createDeliverableType(deliverableType) {
      this.$store.dispatch("createDeliverableType", { deliverableType });
    },
    toggleStatusView() {
      if(this.isMobile()) {
        if(this.expandAll) {
          $('.deliverable-status-overview').hide();
          $('.deliverable-dates').css('padding-top', 0);
        } else {
          $('.deliverable-status-overview').show();
          $('.deliverable-dates').css('padding-top', '15px');
        }
      }
    },
    setPriority() {
      let priority = $('.filter-rating .vue-star-rate ul.list li.active').length;
      this.filterQuery.priorityFilter = priority;
    },
    removeView(viewId) {
      this.$store.dispatch('removeView', viewId);
    },
    loadView() {
      if(this.$router.currentRoute.name == 'project') {
        this.filterQuery = this.$store.getters.projectFilter;
      } else if(this.$router.currentRoute.name == 'myProjects') {
        this.filterQuery = this.$store.getters.myProjectFilter;
      }
    },
    saveView() {
      this.$bvModal.show("viewTitleModal");
    },
    setSort(sortType) {
      this.filterQuery["sort"] = sortType;
    },
    setQuery() {
      this.filterQuery.query = this.searchQuery;
      if(this.$router.currentRoute.name == 'globalSearch') {
        let searchQuery = this.searchQuery;
        let activeTab = this.GSDataType;
        this.$store.commit("setRecentSearch", { searchQuery, activeTab });
      }
    },
    onUpdateDueDate() {
      this.filterQuery.filterByDate = true;
      this.filterQuery.filterNoDueDate = false;
      this.focusFilterBtn();
    },
    onUpdateDateCreated() {
      this.filterQuery.filterByDateCreated = true;
      this.focusFilterBtn();
    },
    onUpdateDateCompleted() {
      this.filterQuery.filterByDateCompleted = true;
      this.focusFilterBtn();
    },

    onWhoSearch(input) {
      if (input != "" || this.initialContacts.length == 0) {
        this.isContactsLoading = true;
        if (typeof window.LIT !== "undefined") {
          clearTimeout(window.LIT);
        }
        window.LIT = setTimeout(() => {
          input = input == false ? "" : input;
          new Promise((resolve, reject) => {
            axios
              .get(
                process.env.MIX_API_BASE_URL + "contacts?q=" + encodeURI(input)
              )
              .then((resp) => {
                this.isContactsLoading = false;
                this.contacts = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  resp.data[x]["name"] =
                    resp.data[x]["first_name"] +
                    " " +
                    resp.data[x]["last_name"];
                  this.contacts.push(resp.data[x]);
                }
                this.$store.commit("setInitialData", {
                  contacts: this.contacts,
                });
                resolve(this.contacts);
              })
              .catch((error) => {
                reject(error);
              });
          });
        }, 500);
      } else {
        this.contacts = this.initialContacts;
      }
    },
    onTagSearch(input) {
      if (input != "" || this.initialTags.length == 0) {
        this.isTagsLoading = true;
        if (typeof window.LIT1 !== "undefined") {
          clearTimeout(window.LIT1);
        }
        window.LIT1 = setTimeout(() => {
          input = input == false ? "" : input;
          new Promise((resolve, reject) => {
            axios
              .get(process.env.MIX_API_BASE_URL + "tags?q=" + encodeURI(input))
              .then((resp) => {
                this.isTagsLoading = false;
                this.tags = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  this.tags.push(resp.data[x]);
                }
                this.$store.commit("setInitialData", { tags: this.tags });
                resolve(this.tags);
              })
              .catch((error) => {
                reject(error);
              });
          });
        }, 500);
      } else {
        this.tags = this.initialTags;
      }
    },
    onDepartmentSearchClose(input) {
      //console.log(input);
    },
    onDepartmentSearch(input) {
      if (input != "" || this.initialDepartments.length == 0) {
        this.isDepartmentsLoading = true;
        if (typeof window.LIT2 !== "undefined") {
          clearTimeout(window.LIT2);
        }
        window.LIT2 = setTimeout(() => {
          input = input == false ? "" : input;
          new Promise((resolve, reject) => {
            axios
              .get(
                process.env.MIX_API_BASE_URL +
                  "activeDepartments?q=" +
                  encodeURI(input)
              )
              .then((resp) => {
                this.isDepartmentsLoading = false;
                this.departments = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  this.departments.push(resp.data[x]);
                }
                this.$store.commit("setInitialData", {
                  departments: this.departments,
                });
                resolve(this.departments);
              })
              .catch((error) => {
                this.isTagsLoading = false;
                reject(error);
              });
          });
        }, 500);
      } else {
        this.departments = this.$store.getters.allActiveDepartments;
      }
    },
    resetFilter() {
      this.$root.$emit('resetView');
      this.filterQuery.filterNoDueDate = false;
      this.filterQuery.noDepartment = "not_accepted";
      this.filterQuery.noCoordinator = "not_accepted";
      this.filterQuery.query = null;
      this.searchQuery = "";
      this.filterQuery.priorityFilter = 0;
      $('.filter-rating .vue-star-rate ul li').each(function() {
        $(this).removeClass('active');
      })
      this.filterQuery.filterByDate = false;
      this.filterQuery.dateRange = {
        startDate: new Date(),
        endDate: new Date(),
      };

      this.filterQuery.filterByDateCreated = false;
      this.filterQuery.dateCreatedRange = {
        startDate: new Date(),
        endDate: new Date(),
      };
      this.filterQuery.sort = '';
      this.filterQuery.coordinator = [];
      this.filterQuery.department = [];
      this.filterQuery.status = [];
    },
    outside() {
      this.showUserSelect = false;
    },
    createNewProject() {
      let that = this;
      that.$store.commit('resetProjectDeliverables')
      this.$store.dispatch("createNewProject").then((resp) => {
        let projectId = resp.project_number;
        if(this.$router.currentRoute.name == 'projectDeliverable') {
          that.$nextTick(() => {
            $(".edit-project-modal .project-title").trigger("click");
          });
          that.$router.push('/project/' + projectId);
        } else {
          that.$store.commit("setNewProjectCreated", true);
          that.setDataLoading(true);
          that.$store.dispatch("fetchProjectDeliverableById", projectId).then(() => {
            that.setDataLoading(false);
            that.$router.push('/project/' + projectId);
          });
        }
        that.$forceUpdate();
        that.$store.dispatch("fetchProjects");
      });
    },
    setStatusFilter(status) {
      if (this.filterQuery.status.indexOf(status) != -1) {
        this.removeFilter(status);
      } else {
        this.filterQuery.status.push(status);
      }
    },
    removeFilter(data) {
      if (typeof data != "undefined") {
        if (typeof data == "string") {
          if(data == 'resetPriorityFilter') {
           this.filterQuery.priorityFilter = 0;
            $('.filter-rating .vue-star-rate ul li').each(function() {
              $(this).removeClass('active');
            });
          }
          if (data == "filterByDate") {
            this.filterQuery.filterByDate = false;
            this.filterQuery.dateRange.startDate = new Date();
            this.filterQuery.dateRange.endDate = new Date();
          }
          if (data == "filterByDateCreated") {
            this.filterQuery.filterByDateCreated = false;
            this.filterQuery.dateCreatedRange.startDate = new Date();
            this.filterQuery.dateCreatedRange.endDate = new Date();
          }
          if (data == "sort") {
            this.filterQuery.sort = "";
          }
        } else {
          this.filterQuery.coordinator = this.filterQuery.coordinator.filter(
            (s) => {
              return s.name != data.name;
            }
          );
          this.filterQuery.department = this.filterQuery.department.filter(
            (s) => {
              return s.name != data.name;
            }
          );
          this.filterQuery.status = this.filterQuery.status.filter((s) => {
            return s.name != data.name;
          });
        }
      } else {
        // TODO:  Check if a filter can be anything other than a string or object.
      }
    },
    triggerSearch() {
      if (this.$refs.searchQuery.value != "") {
        this.setDataLoading(true);
        if (this.$router.currentRoute.name == "project") {
          this.$store.dispatch("fetchProjects").then(() => {
			      this.setDataLoading(false);
          });
        } else {
          this.$store.dispatch("fetchUserProjects").then(() => {
			      this.setDataLoading(false);
          });
        }
      }
    },
    focusFilterBtn() {
      if (typeof this.$refs.filterBoxBtn != "undefined") {
        this.$refs.filterBoxBtn.focus();
      } else if (typeof this.$refs.GSCreatedDate != "undefined") {
        this.GSCreatedDatePopover = false;
      }
    },

    setSort(sortOption) {
      if (this.$router.currentRoute.name == 'project') {
        this.$store.commit("setProjectSort", sortOption.sortString);
      } else if (this.$router.currentRoute.name == 'myProjects') {
        this.$store.commit("setMyProjectSort", sortOption.sortString);
      }

      this.setDataLoading(true);
      if (this.$router.currentRoute.name == "project") {
        this.$store.dispatch("fetchProjects").then(() => {
          this.setDataLoading(false);
        });
      } else {
        this.$store.dispatch("fetchUserProjects").then(() => {
          this.setDataLoading(false);
        });
      }
		},
  },
  watch: {
    filterQuery: {
      handler: function (val, oldVal) {
        this.$root.$emit('showUpdateViewText', {currentFilter: val, isFilterActive: this.isFilterActive()});
        this.filterQuery["myWeek"] = this.myWeek;
        if (
          this.filterQuery.filterByDate &&
          this.filterQuery.dateRange.startDate == null
        ) {
          this.filterQuery.filterByDate = false;
          this.filterQuery.dateRange = {
            startDate: new Date(),
            endDate: new Date(),
          };
          this.filterQuery.filterNoDueDate = true;
        }
        if (this.filterQuery.filterNoDueDate) {
          this.filterQuery.filterByDate = false;
        }
        this.$store.commit("setDeliverableFilter", this.filterQuery);
        if(router.currentRoute.name == 'myProjects') {
          this.setDataLoading(true);
          this.$store.dispatch("fetchUserProjects").then(() => {
			      this.setDataLoading(false);
          });
        } else if(router.currentRoute.name == 'project') {
          this.setDataLoading(true);
          this.$store.dispatch("fetchProjects").then(() => {
			      this.setDataLoading(false);
          });
        }

        if (
          !this.filterQuery.query &&
          !this.filterQuery.filterByDate &&
          !this.filterQuery.filterByDateCreated &&
          !this.filterQuery.coordinator.length &&
          !this.filterQuery.department.length &&
          this.filterQuery.noDepartment != "accepted" &&
          this.filterQuery.noCoordinator != "accepted" &&
          !this.filterQuery.filterNoDueDate &&
          !this.filterQuery.sort &&
          this.filterQuery.priorityFilter == 0 &&
          !this.filterQuery.status.length
        ) {
          $(".project-listing").removeClass("hasFilter");
        } else {
          $(".project-listing").addClass("hasFilter");
        }
      },
      deep: true,
    },
    expandAll: {
      handler: function (val, oldVal) {
        this.$emit("collapseToggleUpdated", val);
      },
    },
  },
};
</script>

<style lang="scss">
.status-wrap {
  display: flex;
  flex-direction: column;
}
</style>
